import React from 'react';

export default function SectionSeparator() {
	return <hr className="border-accent-2 mt-8 mb-12 " />;
}
